import theme from 'shared/styles/theme';

export const BAR_CHART_DIMENSIONS = {
  paddingHorizontal: theme.spacing.m,
  bottomPadding: 30,
  topPadding: 30,
  yAxisLabelWidth: 40,
  barWidth: 40,
  topRadius: 4,
};
